import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from '@emotion/core';

function createScriptTag(src) {
  const script = document.createElement('script');
  if (src) {
    script.setAttribute('src', src);
  }
  script.setAttribute('type', 'text/javascript');
  return script;
}

function appendElementChildToHead(element) {
  const head = document.querySelector('head');
  head.appendChild(element);
}

function addOneTrustSdkStubScript(dataDomainScript, onLoad) {
  const script = createScriptTag('https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
  script.setAttribute('data-domain-script', dataDomainScript);
  script.onload = onLoad;
  appendElementChildToHead(script);
}

function addOneTrustOptanonWrapperScript() {
  const script = createScriptTag();
  script.appendChild(document.createTextNode('function OptanonWrapper() {}'));
  appendElementChildToHead(script);
}

function addCookieLogoOverrideStyle(cookieLogoUrl) {
  const style = document.createElement('style');
  const cssContent = css`
    #ot-sdk-btn-floating .ot-floating-button__front {
      background-image: url(${cookieLogoUrl}) !important;
    }
  `;
  style.textContent = cssContent.styles;
  appendElementChildToHead(style);
}

const CookieConsenter = ({ dataDomainScript, onLoad, partnerConfig }) => {
  const [didSdkStubLoad, setDidSdkStubLoad] = React.useState(false);

  React.useEffect(() => {
    addOneTrustSdkStubScript(dataDomainScript, () => {
      setDidSdkStubLoad(true);
    });
    addOneTrustOptanonWrapperScript();
  }, [dataDomainScript]);

  React.useEffect(() => {
    if (didSdkStubLoad) {
      onLoad();
    }
  }, [didSdkStubLoad, onLoad]);

  React.useEffect(() => {
    if (partnerConfig && partnerConfig.cookieLogoUrl) {
      addCookieLogoOverrideStyle(partnerConfig.cookieLogoUrl);
    }
  }, [partnerConfig]);

  return null;
};

CookieConsenter.propTypes = {
  dataDomainScript: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired,
  partnerConfig: PropTypes.object,
};

const mapStateToProps = (state) => ({
  partnerConfig: state.service?.partnerConfig?.data,
});

export default connect(mapStateToProps)(CookieConsenter);
